module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_7005.9d258deb.png";